import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
// import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";

import CheckIcon from "@mui/icons-material/Check";

// For Modal
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
import { right } from "@popperjs/core";
import AmenityLightBox from "./AmenityLightBox";
// End

import { useEffect } from "react";
import dayjs from "dayjs";

const label = { inputProps: { "aria-label": "Size switch demo" } };

function BookAmenitiesDetailsNew() {
  const navigate = useNavigate();

  // For memu
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  const [amenityName, setAmenityName] = React.useState();
  const [lstAmenityImg, setLstAmenityImg] = React.useState([]);
  const [addedOn, setAddedOn] = React.useState();
  const [description, setDescription] = React.useState();
  const [accessibility, setAccessibility] = React.useState();
  const [amenityFee, setAmenityFee] = React.useState();
  const [cancellationFee, setCancellationFee] = React.useState();
  const [amenityCapecity, setAmenityCapecity] = React.useState();
  const [bookingCapecity, setBookingCapecity] = React.useState();
  const [, setBookingCount] = React.useState();
  const [startTime, setStartTime] = React.useState();
  const [endTime, setEndTime] = React.useState();

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  // const descriptionElementRef = React.useRef(null);

  useEffect(() => {
    let amenityObj = JSON.parse(localStorage.getItem("amenityObj"));
    console.log(amenityObj);

    setAmenityName(amenityObj.amenity_name);
    setLstAmenityImg(amenityObj.lstAmenityImages);
    setDescription(amenityObj.description);
    setAddedOn(amenityObj.created_at);
    setAccessibility(amenityObj.accessibility);
    setAmenityFee(amenityObj.charges);
    setCancellationFee(amenityObj.cancellation_charges);
    setAmenityCapecity(amenityObj.amenity_capacity);
    setBookingCapecity(amenityObj.booking_capacity);
    setBookingCount(amenityObj.bookingCount);

    // console.log('Selected Booking Date ',new Date(selectedDate).getDay())

    let selectedDay = new Date().getDay();

    let dayObj = JSON.parse(
      JSON.stringify(amenityObj.available_days[selectedDay - 1])
    );

    let startTime = dayjs(dayObj.start_time).format("hh:mm a");
    let endTime = dayjs(dayObj.end_time).format("hh:mm a");
    setStartTime(startTime);
    setEndTime(endTime);
  }, []);
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">{amenityName}</h1>

            <Button
              className="contentTopLefBt primaryBtn"
              onClick={() => navigate("/BookAmenityNew")}
            >
              Book Now
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="bookAmMainNew">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="bookAminiDetailsMain">
                    <div className="ameniDetailView">
                      <img src={lstAmenityImg[0]} />
                    </div>
                  </div>
                </div>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContLeft">
                      <p className="visitContHed">
                        Added on: {dayjs(addedOn).format("YYYY-MM-DD hh:mm a")}
                      </p>
                    </div>

                    <div className="resideNewCont">
                      <CreateIcon
                        className="editBt"
                        // onClick={handleClickOpen2("body")}
                        // onClick={() => navigate("/")}
                      />
                      <DeleteIcon className="deleteBt" />
                      <Switch {...label} defaultChecked size="small" />
                    </div>
                  </div>
                  <p className="contTexAminetiNew">{description}</p>
                  <div className="bookingTypMain">
                    <span className="headTyp">Booking type</span>

                    <Button
                      className={accessibility === "Hourly" ? "hrsActiv" : ""}
                    >
                      {accessibility === "Hourly" ? <CheckIcon /> : <></>}{" "}
                      Hourly
                    </Button>
                    <Button
                      className={accessibility === "Half Day" ? "hrsActiv" : ""}
                    >
                      {accessibility === "Half Day" ? <CheckIcon /> : <></>}{" "}
                      Half Day
                    </Button>

                    <Button
                      className={accessibility === "Full Day" ? "hrsActiv" : ""}
                    >
                      {accessibility === "Full Day" ? <CheckIcon /> : <></>}{" "}
                      Full Day
                    </Button>
                  </div>
                  <div className="pricingMain">
                    <h2>Details and pricing deposit structure</h2>
                    <div className="priceTbMain">
                      <table>
                        <tr>
                          <td>Amenity Fee</td>
                          <td style={{ textAlign: right, fontWeight: 500 }}>
                            {amenityFee}
                            {accessibility == "Hourly"}/hr
                          </td>
                        </tr>
                        <tr>
                          <td>Cancellation fee</td>
                          <td style={{ textAlign: right, fontWeight: 500 }}>
                            {cancellationFee}
                          </td>
                        </tr>
                        <tr>
                          <td>Amenity capacity</td>
                          <td style={{ textAlign: right, fontWeight: 500 }}>
                            {amenityCapecity} People
                          </td>
                        </tr>
                        <tr>
                          <td>Booking capacity</td>
                          <td style={{ textAlign: right, fontWeight: 500 }}>
                            {bookingCapecity} People
                          </td>
                        </tr>
                        <tr>
                          <td>Booking Count</td>
                          <td style={{ textAlign: right, fontWeight: 500 }}>
                            Multiple
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="pricingMain operationMain">
                    <h2>Hours of Operations</h2>
                    <div className="operaTimeDiv">
                      <span>Open</span>
                      <span>
                        {startTime} to {endTime}
                      </span>
                    </div>
                  </div>
                  <div className="bookLimitLightBoxMain">
                    <h2>Booking limit</h2>
                    <p>Limited 3 times in a week for one user</p>
                    <div className="ligBoxOut">
                      <AmenityLightBox />
                      <img src={lstAmenityImg[0]} />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default BookAmenitiesDetailsNew;
